<template>
    <main class="audits smaller-padding data-table">
        <v-data-table
            class="audits-table"
            :headers="headers"
            :items="list"
            :loading="loading"
            :custom-sort="dateSort"
            :hide-actions="true"
            no-data-text="Sem dados"
            no-results-text="Sem dados"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <AuditTableItem :audit="props.item" />
            </template>
        </v-data-table>

        <infinite-loading :identifier="infiniteId" @infinite="load">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
        </infinite-loading>
    </main>
</template>

<script>
import AuditTableItem from "@views/audits/components/AuditsTableItem.vue";
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment";
import _ from "lodash";
import provider from "@mixins/provider";

export default {
    components: {
        InfiniteLoading,
        AuditTableItem,
    },

    data() {
        return {
            list: [],
            page: 0,
            loading: false,
            headers: [
                { text: "Operação", value: "operation", sortable: false },
                { text: "Usuário", value: "login", sortable: false },
                { text: "Data", value: "date" },
                { text: "Detalhe", value: "", sortable: false },
            ],
            infiniteId: +new Date(),
            isFiltersLoaded: false,
        };
    },

    computed: {
        filters() {
            return this.$store.state.audit.filters;
        },
    },

    watch: {
        filters: _.debounce(function () {
            this.isFiltersLoaded = true;
            this.list = [];
            this.page = 0;
            this.infiniteId++;
        }, 700),
    },

    mixins: [provider],

    methods: {
        dateSort(items, _index, isDesc) {
            const sorted = items.sort((itemA, itemB) => {
                const dateAMoment = moment(itemA.date).utc();
                const dateBMoment = moment(itemB.date).utc();

                let diff;

                if (isDesc) {
                    diff = dateAMoment.diff(dateBMoment);
                } else {
                    diff = dateBMoment.diff(dateBMoment);
                }

                return diff;
            });

            return sorted;
        },
        async load($state) {
            if (this.isFiltersLoaded) {
                this.loading = true;

                try {
                    const formatedFilter = { ...this.filters };

                    if (formatedFilter.date) {
                        formatedFilter.startDate = formatedFilter.date.min;
                        formatedFilter.endDate = formatedFilter.date.max;
                        delete formatedFilter.date;
                    }

                    const list = await this.$api.audit.list({
                        page: this.page,
                        filters: formatedFilter,
                    });

                    if (list.length) {
                        this.list.push(...list);

                        this.page++;

                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.loading = false;
                }
            }
        },
    },

    destroyed() {},

    mounted() {},

    mixins: [],
};
</script>

<style lang="scss" scoped>
.audits {
    .audits-table {
        padding-bottom: 30px;
    }
}
</style>
